import slugify from "slugify";


export function responseErrorHandling(error:any) {
  throw error && (error.status === 400 || error.status === 413) && error.response
    ? error.response.data
    : new Error("Something went wrong. Please try again!");
}

export function slugifyName(name: string){
  return slugify(name, { lower: true })
}

export function createFormData(data: any): FormData {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof File) {
      formData.append(key, value);
    } else if (typeof value === "object" && value !== null) {
      formData.append(key, JSON.stringify(value));
    } else if (value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  });
  return formData;
}
